/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Weight_ManagementInputs */

const en_service_type_weight_management = /** @type {(inputs: Service_Type_Weight_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight management`)
};

const pl_service_type_weight_management = /** @type {(inputs: Service_Type_Weight_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odchudzanie`)
};

/**
* | output |
* | --- |
* | "Weight management" |
*
* @param {Service_Type_Weight_ManagementInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_weight_management = /** @type {((inputs?: Service_Type_Weight_ManagementInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Weight_ManagementInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_weight_management(inputs)
	return en_service_type_weight_management(inputs)
});